import { render, staticRenderFns } from "./Counteroffer.vue?vue&type=template&id=2a99825d&scoped=true"
import script from "./Counteroffer.vue?vue&type=script&lang=js"
export * from "./Counteroffer.vue?vue&type=script&lang=js"
import style0 from "./Counteroffer.vue?vue&type=style&index=0&id=2a99825d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99825d",
  null
  
)

export default component.exports